import type { ShipmentProductHazmatResponse } from './api';

export const normalizeShipmentProductHazmat = (
  list: ShipmentProductHazmatResponse,
): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.text,
    value: row.value,
  }));
};
